const amountSaved = 'Amount saved:';
const amountSavedToDate = 'Amount saved to date?';
const howMuchBorrow = 'How much do you anticipate borrowing?';
const howMuchNeed = 'How much do you expect to need?';
const howMuchLabel = 'Needed';
const howSoon = 'Time:';
const wantToBorrow = 'Borrow:';
const whatType = 'Type:';
const selectAll = 'Select all that apply';
const checkingBanking = 'Checking & Banking';
const saveInvest = 'Save & Invest';
const loansLines = 'Loans & Lines of Credit';
const creditCards = 'Credit Cards';
const financialScore = 'Learn Your Financial Health Score';
const guideTitle = '| Regions Consumer Online';

export default {
  'guide.name': 'Regions Consumer Online',

  'header.landing': 'Welcome to Regions',
  'header.entry': 'Getting To Know You',
  'header.bank': ' ',
  'header.saveAndInvest': ' ',
  'header.loansAndLines': ' ',
  'header.creditCards': ' ',
  'header.demographics': ' ',
  'header.logo.url': 'http://www.regions.com/',

  'landing.title': 'Find solutions that best fit your banking needs',
  'landing.subtitle': 'Answer questions to take the next steps in achieving your financial goals',
  'landing.getStarted': 'Get Started',
  'landing.footer.header': 'Important Legal Disclosures and Information',
  'landing.disclosures.permanentDisclosure': 'This tool is provided by Regions Bank for educational and general marketing purposes only and should not be construed as a recommendation or suggestion as to the advisability of acquiring, holding or disposing of a particular investment, nor should it be construed as a suggestion or indication that the particular investment or investment course of action described herein is appropriate for any specific retirement investor. In providing this communication, Regions Bank is not undertaking to provide impartial investment advice or to give advice in a fiduciary capacity.',
  'landing.disclosure.fdic': 'Member FDIC. <a href="#!">Equal Housing Lender</a>',
  'landing.disclosure.copyright': 'Regions Bank. All rights reserved',
  'landing.disclosureLink.about': 'About Regions',
  'landing.disclosureLink.relations': 'Investor Relations',
  'landing.disclosureLink.privacy': 'Privacy &amp; Security',
  'landing.disclosureLink.terms': 'Website Terms of Use',
  'landing.disclosureLink.reports': 'Economic Reports',
  'landing.disclosureLink.property': 'Property for Sale',
  'landing.disclosureLink.tracking': 'Online Tracking and Advertising',
  'landing.disclosureLink.call': 'Call <a href="#!">1-800-REGIONS</a>',

  'surveyPage.meta.title.entry.reasonForVisit': `Banking Needs ${guideTitle}`,
  'surveyPage.meta.title.entry.relationship': `Current Customer ${guideTitle}`,
  'surveyPage.meta.title.bank.checkingBalance': `Checking Balance ${guideTitle}`,
  'surveyPage.meta.title.bank.customerRelationship': `Customer Relationship ${guideTitle}`,
  'surveyPage.meta.title.bank.directDepositAmount': `Direct Deposits ${guideTitle}`,
  'surveyPage.meta.title.bank.numberOfChecksWritten': `Checks Written ${guideTitle}`,
  'surveyPage.meta.title.bank.numberOfDebitCardTransactions': `Card Transactions ${guideTitle}`,
  'surveyPage.meta.title.bank.checkingAccessMethod': `Purchases ${guideTitle}`,
  'surveyPage.meta.title.saveAndInvest.savings': `Savings Goals ${guideTitle}`,
  'surveyPage.meta.title.saveAndInvest.retirementSavingsMethod': `Retirement Savings ${guideTitle}`,
  'surveyPage.meta.title.saveAndInvest.contributionFrequencySavings': `Non-Retirement Contributions ${guideTitle}`,
  'surveyPage.meta.title.saveAndInvest.accessMoneyFrequency': `Non-Retirement Withdrawals ${guideTitle}`,
  'surveyPage.meta.title.saveAndInvest.regionsCheckingAccountType': `Regions Relationship ${guideTitle}`,
  'surveyPage.meta.title.saveAndInvest.checkingOver5000': `Checking Balance ${guideTitle}`,
  'surveyPage.meta.title.loansAndLines.home': `Own or Rent ${guideTitle}`,
  'surveyPage.meta.title.loansAndLines.goals': `Borrowing Goals ${guideTitle}`,
  'surveyPage.meta.title.loansAndLines.firstTimeHomeBuyer': `Home Ownership ${guideTitle}`,
  'surveyPage.meta.title.loansAndLines.wantToBorrowFromHomeEquity': `Home Equity ${guideTitle}`,
  'surveyPage.meta.title.loansAndLines.homeLoanType': `Borrow for Home ${guideTitle}`,
  'surveyPage.meta.title.loansAndLines.loanCollateralType': `Loan Collateral ${guideTitle}`,
  'surveyPage.meta.title.creditCards.creditCardFeaturesBorrow': `Credit Card Features ${guideTitle}`,
  'surveyPage.meta.title.creditCards.creditCardPointsType': `Credit Card Rewards ${guideTitle}`,
  'surveyPage.meta.title.demographics.militaryLeaveActBorrow': `Military Leave ${guideTitle}`,
  'surveyPage.meta.title.demographics.demographics': `Demographics ${guideTitle}`,
  'surveyPage.meta.title.financialHealthScore.householdSpending': `Household Spending ${guideTitle}`,
  'surveyPage.meta.title.financialHealthScore.householdBills': `Household Bills ${guideTitle}`,
  'surveyPage.meta.title.financialHealthScore.expenseTimeFrame': `Expense Timing ${guideTitle}`,
  'surveyPage.meta.title.financialHealthScore.householdGoalConfidence': `Household Goals ${guideTitle}`,
  'surveyPage.meta.title.financialHealthScore.householdDebts': `Household Debts ${guideTitle}`,
  'surveyPage.meta.title.financialHealthScore.creditExperience': `Credit ${guideTitle}`,
  'surveyPage.meta.title.financialHealthScore.householdInsuranceConfidence': `Household Insurance ${guideTitle}`,
  'surveyPage.meta.title.financialHealthScore.householdPlanningConfidence': `Household Planning ${guideTitle}`,

  'summary.financialHealthScore': 'Your Financial Health Score =',
  'summary.financialHealthScoreTitle': 'See your financial health score in minutes!',
  'summary.financialHealthScoreDescription': 'Financial health score description goes here',
  'summary.financialHealthScoreUrl': 'http://',
  'summary.finScoreVulnerable': 'Financially Vulnerable',
  'summary.finScoreCoping': 'Financially Sound',
  'summary.finScoreHealthy': 'Financially Thriving',
  'summary.recommendationId': 'Your recommendation #{uuid} was updated {date}',
  'summaryPage.meta.title': `Summary ${guideTitle}`,

  'pathOptions.pathingHeader': 'Answer more questions to find additional products for your needs',
  'pathOptions.pathingCheckingBanking': checkingBanking,
  'pathOptions.pathingSaveInvest': saveInvest,
  'pathOptions.pathingLoansLines': loansLines,
  'pathOptions.pathingCreditCards': creditCards,
  'pathOptions.pathingFinancialScore': financialScore,

  'summary.healthScoreForSpending': 'Spend',
  'summary.healthScoreForSaving': 'Save',
  'summary.healthScoreForBorrow': 'Borrow',
  'summary.healthScoreForPlanning': 'Planning',

  'product.applyNow': 'Apply Now',
  'product.appointment': 'Make an Appointment',
  'product.appointmentScheduled': 'Appointment Scheduled',
  'product.financialAdvisor': 'Contact a Financial Advisor',
  'product.wealthAdvisor': 'Contact a Wealth Advisor',
  'product.Submit': 'Submit',

  'details.recommendations': 'Your Personalized Product Recommendations',
  'details.financialScore': 'Your Personalized Financial Score',
  'detailsPage.meta.title': `Details ${guideTitle}`,

  'contactForm.modal.title': 'Make an Appointment',
  'contactMeForm.formInput.firstName': 'First Name:',
  'contactMeForm.formInput.firstName.placeholder': 'First Name',
  'contactMeForm.formInput.lastName': 'Last Name:',
  'contactMeForm.formInput.lastName.placeholder': 'Last Name',
  'contactMeForm.formInput.email': 'Email:',
  'contactMeForm.formInput.email.placeholder': 'address@website.com',
  'contactMeForm.formInput.phone': 'Phone Number:',
  'contactMeForm.formInput.phone.placeholder': '214-123-4567',

  'appointmentLocationForm.formInput.zipCode': 'Zip Code',
  'formInput.zipCode.placeholder': 'Enter your postal code',

  'error.question.required': 'Must be answered. ',
  'error.question.zipCode': 'Must enter a valid zip code. ',
  'error.question.outOfFootprint': 'Unfortunately, since we do not currently have branches in your state, we are unable to open an account with you at this time. If you are moving and entered in the ZIP code of your current residence, please input the ZIP code of your future residence.',

  reasonForVisit: 'Find the products that best fit your banking needs.',
  'reasonForVisit.subtext': selectAll,
  'reasonForVisit.bank': checkingBanking,
  'reasonForVisit.bank.icon': '/classpath/assets/images/regions-icons/accounts.svg',
  'reasonForVisit.saveAndInvest': saveInvest,
  'reasonForVisit.saveAndInvest.icon': '/classpath/assets/images/regions-icons/savings.svg',
  'reasonForVisit.loansAndLines': loansLines,
  'reasonForVisit.loansAndLines.icon': '/classpath/assets/images/regions-icons/borrow-gray.svg',
  'reasonForVisit.creditCards': creditCards,
  'reasonForVisit.creditCards.icon': '/classpath/assets/images/regions-icons/card-check.svg',

  bankingRelationship: 'Are you a current customer of Regions?',
  'bankingRelationship.yesPersonal': 'Personal',
  'bankingRelationship.yesBusiness': 'Business',
  'bankingRelationship.yesBoth': 'Both',
  'bankingRelationship.no': 'No, not yet',

  checkingBalance: 'What is your average checking balance?',
  'checkingBalance.tooltip': 'The amount you typically carry in your checking account for normal purposes each month',

  customerRelationship: 'Do any of these apply to your relationship with Regions?',
  'customerRelationship.balanceCheckingGroup': 'Have a combined balance of $25,000 or more in checking, savings, money markets and CDs with Regions',
  'customerRelationship.balanceLoanGroup': 'Have a combined balance of $25,000 or more in loans, lines of credit, and credit cards with Regions',
  'customerRelationship.balanceMortgageLoan': 'Have a mortgage loan with Regions',
  'customerRelationship.none': 'None of the above',

  directDepositAmount: 'Which describes your direct deposits each month?',
  'directDepositAmount.1000': 'Direct deposits totaling $1000 or more each month',
  'directDepositAmount.500': 'At least one direct deposit of $500 or more each month',
  'directDepositAmount.300': 'At least one direct deposit of $300 or more each month',
  'directDepositAmount.0': 'None of the above',

  numberOfChecksWritten: 'How many checks do you write each month?',
  'numberOfChecksWritten.12': '12 checks or more',
  'numberOfChecksWritten.1': '1 to 12 checks',
  'numberOfChecksWritten.0': 'I don\'t write checks',

  numberOfDebitCardTransactions: 'How many times do you use a debit or credit card each month?',
  'numberOfDebitCardTransactions.tooltip': 'Debit card and/or credit card must be with Regions.',
  'numberOfDebitCardTransactions.10': '10 debit and/or credit card uses or more',
  'numberOfDebitCardTransactions.9': ' 1 to 9 debit and/or credit card uses',
  'numberOfDebitCardTransactions.0': 'I don’t use cards',

  checkingAccessMethod: 'How else do you like to make purchases?',
  'checkingAccessMethod.subtext': selectAll,
  'checkingAccessMethod.cash': 'Primarily cash',
  'checkingAccessMethod.card': 'Prepaid card',
  'checkingAccessMethod.moneyOrders': 'Money orders',
  'checkingAccessMethod.westernUnion': 'Western Union',
  'checkingAccessMethod.other': 'Other',

  'overdraftFees': 'Which is most important to you?',
  'overdraftsGroup': 'At Regions, we want to be mindful of fees, specifically overdraft fees when transactions exceed the available balance in your checking account (such as when you are at the gas station, grocery stores, etc.)',
  'overdraftFees.flexibility': '<b>Flexibility:</b> Certain transactions may be paid with a fee (please see Standard Overdraft Coverage below)',
  'overdraftFees.predictability': '<b>Predictability</b>: Consistent, non-waivable monthly account fee and no Regions overdraft fees but the transaction will be declined ',

  savingsGoalTypes: 'Goals',
  savingsQuestionGroup: 'What do you wish to achieve with your savings?',
  'savingsQuestionGroup.subtext': selectAll,
  'savingsGoalTypes.cardBuilder.removeCard': '<icon>fa fa-times-circle</icon>',
  'savingsGoalTypes.cardBuilder.editCard': '<icon>fa fa-edit</icon>',
  'savingsGoalTypes.cardBuilder.addCard': '<icon>fa fa-plus</icon><span>Add Goal</span>',
  'savingsGoalTypes.cardBuilder.modal.title': 'Please select a goal:',
  'savingsGoalTypes.cardBuilder.input.label': 'Filter results:',
  'savingsGoalTypes.cardBuilder.input.placeholder': 'e.g.: Home',
  'savingsGoalTypes.cardBuilder.saveCard': 'Save',

  'savingsGoalTypes.rainyDayGoal': 'Rainy Day / Emergency Fund',
  'savingsGoalTypes.rainyDayGoal.label': 'Rainy Day / Emergency Fund',
  'savingsGoalTypes.rainyDayGoal.icon': '/classpath/assets/images/regions-icons/shield.svg',
  'savingsGoalTypes.retirementFundGoal': 'Retirement Fund',
  'savingsGoalTypes.retirementFundGoal.label': 'Retirement Fund',
  'savingsGoalTypes.retirementFundGoal.icon': '/classpath/assets/images/regions-icons/wallet.svg',
  'savingsGoalTypes.collegeFundGoal': 'College Fund',
  'savingsGoalTypes.collegeFundGoal.label': 'College Fund',
  'savingsGoalTypes.collegeFundGoal.icon': '/classpath/assets/images/regions-icons/school-years.svg',
  'savingsGoalTypes.eventWeddingGoal': 'Special Event',
  'savingsGoalTypes.eventWeddingGoal.label': 'Special Event',
  'savingsGoalTypes.eventWeddingGoal.tooltip': 'Wedding, Vacation, First Child, etc.',
  'savingsGoalTypes.eventWeddingGoal.icon': '/classpath/assets/images/regions-icons/check.svg',
  'savingsGoalTypes.provideForChildGoal': 'Provide for Child / Grandchild',
  'savingsGoalTypes.provideForChildGoal.label': 'Provide for Child / Grandchild',
  'savingsGoalTypes.provideForChildGoal.icon': '/classpath/assets/images/regions-icons/icon-people.svg',
  'savingsGoalTypes.otherSavingsGoal': 'Other Savings Purpose',
  'savingsGoalTypes.otherSavingsGoal.label': 'Other Savings Purpose',
  'savingsGoalTypes.otherSavingsGoal.tooltip': 'Other Savings Purpose',
  'savingsGoalTypes.otherSavingsGoal.icon': '/classpath/assets/images/regions-icons/icon-other.svg',

  rainyDayGoal: 'What type of account do you desire?',
  'rainyDayGoal.cardBuilder.title': 'Rainy Day or Emergency Fund',
  'details.rainyDayGoal': 'Goals: Rainy day | What type of account do you desire?',
  rainyDayGoalAmount: 'How much cushion would you like to have?',
  'rainyDayGoalAmount.cardBuilder.answerLabel': 'Cushion:',
  rainyDayGoalSavedToDate: amountSavedToDate,
  'rainyDayGoalSavedToDate.cardBuilder.answerLabel': amountSaved,

  retirementFundGoal: 'Retirement Fund',
  'retirementFundGoal.cardBuilder.title': 'Retirement Fund',
  'details.retirementFund`Goal': 'Goals: Retirement Fund | What type of account do you desire?',
  retirementFundGoalTiming: 'When do you plan to retire?',
  'retirementFundGoalTiming.cardBuilder.answerLabel': howSoon,
  'retirementFundGoalTiming.1': 'Already retired',
  'retirementFundGoalTiming.0.tooltip': 'Wish to protect and manage retirement savings and investments accumulated to-date. Examples include distributions for optimal tax protection, passing to heirs, and ensuring enough funds are available.',
  'retirementFundGoalTiming.2': 'Less than 3 years from now',
  'retirementFundGoalTiming.3': '3 to 9 years from now',
  'retirementFundGoalTiming.10': '10 years or more from now',
  retirementFundGoalAmount: amountSavedToDate,
  'retirementFundGoalAmount.tooltip': 'The amount you have accumulated in your retirement savings',
  'retirementFundGoalAmount.cardBuilder.answerLabel': amountSaved,
  'retirementFundGoalAmount.1': 'None yet',
  'retirementFundGoalAmount.14999': '$50 to $14,999',
  'retirementFundGoalAmount.249999': '$15,000 to $249,999',
  'retirementFundGoalAmount.499999': '$250,000 to $499,999',
  'retirementFundGoalAmount.500000': '$500,000 or more',

  collegeFundGoal: 'College Fund',
  'collegeFundGoal.cardBuilder.title': 'College Fund',
  'details.collegeFundGoal': 'Goals: College Fund | What type of account do you desire?',
  collegeFundGoalAmount: 'How much will you need?',
  'collegeFundGoalAmount.cardBuilder.answerLabel': howMuchLabel,
  collegeFundGoalSavedToDate: amountSavedToDate,
  'collegeFundGoalSavedToDate.cardBuilder.answerLabel': amountSaved,
  collegeFundGoalWantToBorrow: 'Would you like to borrow to reach this goal more quickly?',
  'collegeFundGoalWantToBorrow.cardBuilder.answerLabel': wantToBorrow,
  'collegeFundGoalWantToBorrow.true': 'Yes',
  'collegeFundGoalWantToBorrow.false': 'No',

  eventWeddingGoal: 'Special Event',
  'eventWeddingGoal.tooltip': 'wedding, Vacation, First Child, etc.',
  'eventWeddingGoal.cardBuilder.title': 'Special event',
  'details.eventWeddingGoal': 'Goals: Special event | What type of account do you desire?',
  eventWeddingGoalAmount: 'How much will you need?',
  'eventWeddingGoalAmount.cardBuilder.answerLabel': howMuchLabel,
  eventWeddingGoalSavedToDate: amountSavedToDate,
  'eventWeddingGoalSavedToDate.cardBuilder.answerLabel': amountSaved,
  eventWeddingGoalWantToBorrow: 'Would you like to borrow to reach this goal more quickly?',
  'eventWeddingGoalWantToBorrow.cardBuilder.answerLabel': wantToBorrow,
  'eventWeddingGoalWantToBorrow.true': 'Yes',
  'eventWeddingGoalWantToBorrow.false': 'No',

  provideForChildGoal: 'Provide for Child / Grandchild',
  'provideForChildGoal.cardBuilder.title': 'Provide for child or grandchild',
  'details.provideForChildGoal': 'Goals: Provide for Child / Grandchild | What type of account do you desire?',
  provideForChildGoalAmount: 'How much will you need?',
  'provideForChildGoalAmount.cardBuilder.answerLabel': howMuchLabel,
  provideForChildGoalSavedToDate: amountSavedToDate,
  'provideForChildGoalSavedToDate.cardBuilder.answerLabel': amountSaved,

  otherSavingsGoal: 'Other Savings Purpose',
  'otherSavingsGoal.tooltip': 'Major purchase, vehicle, travel, medical, etc.',
  'otherSavingsGoal.cardBuilder.title': 'Other Savings Purpose (vehicle, major purchase, travel, medical, etc.)',
  'details.otherSavingsGoal': 'Goals: Other Savings Purpose | What type of account do you desire?',
  otherSavingsGoalAmount: 'How much will you need?',
  'otherSavingsGoalAmount.cardBuilder.answerLabel': howMuchLabel,
  otherSavingsGoalSavedToDate: amountSavedToDate,
  'otherSavingsGoalSavedToDate.cardBuilder.answerLabel': amountSaved,

  retirementSavingsMethod: 'How are you saving for retirement?',
  'retirementSavingsMethod.subtext': selectAll,
  'retirementSavingsMethod.starting': 'Just starting',
  'retirementSavingsMethod.401kPotential': 'Not contributing, but employer offers 401(k) or 403(b)',
  'retirementSavingsMethod.401kPotential.tooltip': 'Employer offers a retirement plan for employees to contribute pre-tax monies but you’re not currently contributing to it.',
  'retirementSavingsMethod.401kCurrentEmployer': '401(k) or 403(b) plan with <i>current</i> employer',
  'retirementSavingsMethod.401kCurrentEmployer.tooltip': 'This type of retirement plan is sponsored by an employer that allows employees to make a pre-tax contribution for retirement purposes.',
  'retirementSavingsMethod.401kFormerEmployer': '401(k) or 403(b) plan with <i>former</i> employer',
  'retirementSavingsMethod.401kFormerEmployer.tooltip': 'This type of retirement plan is sponsored by an employer that allows employees to make a pre-tax contribution for retirement purposes.',
  'retirementSavingsMethod.ira': 'IRA (Individual Retirement Plan)',
  'retirementSavingsMethod.ira.tooltip': 'This plan can be a traditional IRA or Roth IRA, which is funded by an individual (not employer).',
  'retirementSavingsMethod.other': 'Other',
  'retirementSavingsMethod.other.tooltip': 'You are building retirement savings outside of the plans named above.',

  contributionFrequencySavings: 'How frequently do you expect to make <strong>contributions</strong> to your <strong>non-retirement</strong> savings?',
  'contributionFrequencySavings.tooltip': 'Savings you are accumulating for purposes other than retirement',
  'contributionFrequencySavings.weekly': 'Weekly',
  'contributionFrequencySavings.monthly': 'Monthly',
  'contributionFrequencySavings.quarterly': 'Quarterly',
  'contributionFrequencySavings.yearly': 'Annually',
  'contributionFrequencySavings.infrequently': 'Rarely',

  accessMoneyFrequency: 'How frequently do you expect to <strong>withdraw from</strong> your <strong>non-retirement</strong> savings?',
  'accessMoneyFrequency.weekly': 'Weekly',
  'accessMoneyFrequency.monthly': 'Monthly',
  'accessMoneyFrequency.quarterly': 'Quarterly',
  'accessMoneyFrequency.yearly': 'Annually',
  'accessMoneyFrequency.infrequently': 'Rarely',

  regionsCheckingAccountType: 'Do any of these apply to your current Regions relationship?',
  'regionsCheckingAccountType.checking': 'I have a Regions checking account',
  'regionsCheckingAccountType.nowCard': 'I have a Regions Now Card (reloadable prepaid card)',
  'regionsCheckingAccountType.none': 'Neither of these',

  checkingOver5000: 'Do you usually have $5,000 or more in your checking account?',
  'checkingOver5000.true': 'Yes',
  'checkingOver5000.false': 'No',

  homePropertyType: 'Do you own or rent your home?',
  'homePropertyType.own': 'Own',
  'homePropertyType.rent': 'Rent',
  'homePropertyType.friends': 'Live with friends/relatives',

  borrowGoalTypes: 'Goals',
  borrowGoalQuestionGroup: 'For which of these goals do you expect to borrow money?',
  'borrowGoalQuestionGroup.subtext': selectAll,
  'borrowGoalTypes.cardBuilder.saveCard': 'Save',
  'borrowGoalTypes.cardBuilder.removeCard': '<icon>fa fa-times-circle</icon>',
  'borrowGoalTypes.cardBuilder.editCard': '<icon>fa fa-edit</icon>',
  'borrowGoalTypes.cardBuilder.addCard': '<icon>fa fa-plus</icon><span>Add Goal</span>',
  'borrowGoalTypes.cardBuilder.modal.title': 'Please select a goal:',
  'borrowGoalTypes.cardBuilder.input.label': 'Filter results:',
  'borrowGoalTypes.cardBuilder.input.placeholder': 'e.g.: Home',

  'borrowGoalTypes.purchaseHomeGoal': 'Buy a Home',
  'borrowGoalTypes.purchaseHomeGoal.label': 'Buy a Home',
  'borrowGoalTypes.purchaseHomeGoal.icon': '/classpath/assets/images/regions-icons/house.svg',
  'borrowGoalTypes.refinanceHomeGoal.label': 'Refinance a Home',
  'borrowGoalTypes.refinanceHomeGoal.tooltip': 'To get a better interest rate, make lower monthly payments or get cash out',
  'borrowGoalTypes.refinanceHomeGoal.icon': '/classpath/assets/images/regions-icons/house-green.svg',
  'borrowGoalTypes.homeImprovementGoal': 'Improve Home',
  'borrowGoalTypes.homeImprovementGoal.label': 'Improve Home',
  'borrowGoalTypes.homeImprovementGoal.icon': '/classpath/assets/images/regions-icons/house-heart.svg',
  'borrowGoalTypes.payOffDebtsGoal': 'Pay off Debts',
  'borrowGoalTypes.payOffDebtsGoal.label': 'Pay off Debts',
  'borrowGoalTypes.payOffDebtsGoal.icon': '/classpath/assets/images/regions-icons/icon-payoff.svg',
  'borrowGoalTypes.purchaseVehicleGoal': 'Buy a Vehicle',
  'borrowGoalTypes.purchaseVehicleGoal.label': 'Buy a Vehicle',
  'borrowGoalTypes.purchaseVehicleGoal.icon': '/classpath/assets/images/regions-icons/car-motorcycle.svg',
  'borrowGoalTypes.refinanceVehicleGoal': 'Refinance a Vehicle',
  'borrowGoalTypes.refinanceVehicleGoal.label': 'Refinance a Vehicle',
  'borrowGoalTypes.refinanceVehicleGoal.icon': '/classpath/assets/images/regions-icons/car-motorcycle-refi.svg',
  'borrowGoalTypes.collegeEducationGoal': 'Fund a College Education',
  'borrowGoalTypes.collegeEducationGoal.label': 'Fund a College Education',
  'borrowGoalTypes.collegeEducationGoal.icon': '/classpath/assets/images/regions-icons/school-years.svg',
  'borrowGoalTypes.otherBorrowingGoal': 'Other Borrowing Goal',
  'borrowGoalTypes.otherBorrowingGoal.label': 'Other Borrowing Goal',
  'borrowGoalTypes.otherBorrowingGoal.tooltip': 'Vacation/travel, medical expenses, unexpected event, emergency, etc.',
  'borrowGoalTypes.otherBorrowingGoal.icon': '/classpath/assets/images/regions-icons/icon-other.svg',

  purchaseHomeGoal: 'Buy a Home',
  'purchaseHomeGoal.cardBuilder.title': 'Buy a Home',
  'details.purchaseHomeGoal': 'Goals: Buy a Home | What type of account do you desire?',
  purchaseHomeGoalType: 'What type of home?',
  'purchaseHomeGoalType.cardBuilder.answerLabel': whatType,
  'purchaseHomeGoalType.firstHome': 'First home',
  'purchaseHomeGoalType.biggerSmallerHome': 'Bigger or smaller primary home',
  'purchaseHomeGoalType.secondHome': 'Second or investment home',
  purchaseHomeGoalAmount: 'How much do you anticipate borrowing (purchase price after your down payment)?',
  'purchaseHomeGoalAmount.cardBuilder.answerLabel': 'Price:',
  purchaseHomeGoalExpectancy: 'Expect to stay in the home more than six years?',
  'purchaseHomeGoalExpectancy.true': 'Yes',
  'purchaseHomeGoalExpectancy.false': 'No',

  refinanceVehicleGoal: 'Refinance a Car, Truck or Van',
  'refinanceVehicleGoal.cardBuilder.title': 'Refinance a Car, Truck or Van',
  'refinanceVehicleGoal.cardBuilder.modal.subtitle': 'How much do you expect to need?',
  'details.refinanceVehicleGoal': 'Goals: Refinance a Car, Truck or Van | What type of account do you desire?',
  refinanceCarTruckVanGoalAmount: 'For your Car, Truck or Van?',
  refinanceMotorcycleGoalAmount: 'For your Motorcycle?',
  refinanceRecreationalVehicleGoalAmount: 'For your RV?',
  refinanceBoatVehicleGoalAmount: 'For your Boat?',
  'refinanceVehicleGoalAmount.cardBuilder.answerLabel': howMuchLabel,

  refinanceHomeGoal: 'Refinance a Home',
  'refinanceHomeGoal.cardBuilder.title': 'Refinance a Home',
  'details.refinanceHomeGoal': 'Goals: Refinance a Home | What type of account do you desire?',
  refinanceHomeGoalType: 'What type of home?',
  'refinanceHomeGoalType.cardBuilder.answerLabel': whatType,
  'refinanceHomeGoalType.singleFamily': 'Single family',
  'refinanceHomeGoalType.townhome': 'Townhome',
  'refinanceHomeGoalType.condominium': 'Condominium',
  'refinanceHomeGoalType.mobileHome': 'Mobile home',
  refinanceHomeGoalAmount: howMuchBorrow,
  'refinanceHomeGoalAmount.cardBuilder.answerLabel': howMuchLabel,
  refinanceHomeGoalExpectancy: 'Expect to stay in the home more than six years?',
  'refinanceHomeGoalExpectancy.true': 'Yes',
  'refinanceHomeGoalExpectancy.false': 'No',

  homeImprovementGoal: 'Improve a home',
  'homeImprovementGoal.cardBuilder.title': 'Improve a home',
  'details.homeImprovementGoal': 'Goals: Improve a home | What type of account do you desire?',
  homeImprovementGoalAmount: howMuchBorrow,
  'homeImprovementGoalAmount.cardBuilder.answerLabel': howMuchLabel,

  payOffDebtsGoal: 'Pay off Debts',
  'payOffDebtsGoal.cardBuilder.title': 'Pay off Debts',
  'details.payOffDebtsGoal': 'Goals: Pay off Debts | What type of account do you desire?',
  payOffDebtsGoalAmount: howMuchBorrow,
  'payOffDebtsGoalAmount.cardBuilder.answerLabel': howMuchLabel,

  purchaseVehicleGoal: 'Buy a Vehicle',
  'purchaseVehicleGoal.cardBuilder.title': 'Buy a Vehicle',
  'details.purchaseVehicleGoal': 'Goals: Buy a Vehicle | What type of account do you desire?',
  purchaseCarTruckVanGoalAmount: 'For your Car, Truck or Van?',
  purchaseMotorcycleGoalAmount: 'For your Motorcycle?',
  purchaseRecreationalVehicleGoalAmount: 'For your RV?',
  purchaseBoatVehicleGoalAmount: 'For your Boat?',
  'purchaseVehicleGoalAmount.cardBuilder.answerLabel': howMuchLabel,

  collegeEducationGoal: 'Fund a College Education',
  'collegeEducationGoal.cardBuilder.title': 'Fund a College Education',
  'details.collegeEducationGoal': 'Goals: Fund a College Education | What type of account do you desire?',
  collegeEducationGoalAmount: howMuchNeed,
  'collegeEducationGoalAmount.cardBuilder.answerLabel': howMuchLabel,

  otherBorrowingGoal: 'Other Borrowing Goal',
  'otherBorrowingGoal.cardBuilder.title': 'Other Borrowing Goal',
  'details.otherBorrowingGoal': 'Goals: Other Borrowing Goal | What type of account do you desire?',
  otherBorrowingGoalAmount: howMuchNeed,
  'otherBorrowingGoalAmount.cardBuilder.answerLabel': howMuchLabel,

  goalsTotalAmount: 'Total Savings Goal Amount',
  goalsTotalAmountSavedToDate: 'Total Saved To Date',
  totalGoalAmount: 'Total Goals Amount',
  totalGoalAmountSavedToDate: 'Total Goals Amount Saved To Date',

  firstTimeHomeBuyer: 'Have you owned a home in the past 3 years?',
  'firstTimeHomeBuyer.true': 'Yes',
  'firstTimeHomeBuyer.false': 'No',

  wantToBorrowFromHomeEquity: 'Would you like to borrow from the equity in your home?',
  'wantToBorrowFromHomeEquity.tooltip': 'Equity is the current market value of the house minus any outstanding loan balances.  Funds from an equity loan may be used however you choose.',
  'wantToBorrowFromHomeEquity.true': 'Yes',
  'wantToBorrowFromHomeEquity.false': 'No',

  homeLoanType: 'How would you prefer to borrow the funds?',
  'homeLoanType.upFront': 'All up front',
  'homeLoanType.upFront.tooltip': 'Loan with fixed payment amount each month.',
  'homeLoanType.overTime': 'Over time',
  'homeLoanType.overTime.tooltip': 'Line of credit, where the payment amount adjusts based on the balance owed.',

  homeLoanTiming: 'How quickly do you need the funds?',
  'homeLoanTiming.1': 'Within a week',
  'homeLoanTiming.6': '2 weeks to 6 months',
  'homeLoanTiming.7': 'More than 6 months',

  borrowGoalTotalAmount: 'Total amount to borrow',

  loanCollateralType: 'To lower your borrowing interest rate, would you like to use a savings, money market account or CD as collateral for the loan?',
  'loanCollateralType.tooltip': "One benefit of borrowing from your savings/CD is a lower interest rate than an unsecured loan. Although you won't have access to your collateral during the life of the loan, your collateral will continue to earn interest.",
  'loanCollateralType.savings': 'Yes, I’d like to use my current Regions savings, money market account or CD',
  'loanCollateralType.bankProductSavings': 'Yes, I’d like to open a Regions savings, money market account or CD',
  'loanCollateralType.no': 'No',

  militaryLeaveActBorrow: 'Are you currently subject to the Military Leave Act?',
  'militaryLeaveActBorrow.true': 'Yes',
  'militaryLeaveActBorrow.true.tooltip': 'Active duty service member or a dependent of an active duty service member.',
  'militaryLeaveActBorrow.false': 'No',

  creditCardFeaturesBorrow: "For you, what's the most important feature of a credit card?",
  'creditCardFeaturesBorrow.rewards': 'Cash rewards',
  'creditCardFeaturesBorrow.rewards.icon': '/classpath/assets/images/regions-icons/wallet.svg',
  'creditCardFeaturesBorrow.rewardsChoose': 'Choose my rewards',
  'creditCardFeaturesBorrow.rewardsChoose.tooltip': 'Earn points that can be redeemed for cash, travel, merchandise or gift cards',
  'creditCardFeaturesBorrow.rewardsChoose.icon': '/classpath/assets/images/regions-icons/target.svg',
  'creditCardFeaturesBorrow.lowInterest': 'Low interest rate (no rewards)',
  'creditCardFeaturesBorrow.lowInterest.icon': '/classpath/assets/images/regions-icons/shield.svg',
  'creditCardFeaturesBorrow.eligible': 'Ability to be approved for credit',
  'creditCardFeaturesBorrow.eligible.icon': '/classpath/assets/images/regions-icons/icon-other.svg',

  creditCardPointsType: 'Which type of rewards do you prefer?',
  'creditCardPointsType.rewards': 'Earning rewards with no annual fee ',
  'creditCardPointsType.moreRewards': 'Earning more rewards with an annual fee',
  creditCardPointsDetailsUrl: 'See rewards details',
  creditCardPointsPricingInfo: 'Pricing Information',

  age: 'Age & Zip Code',
  'age.subtext': 'Select to ensure your recommendations are right for you',
  'age.23': '18 to 23 years',
  'age.61': '24 to 61 years',
  'age.62': '62 years+',

  postalCode: 'Enter your Zip code',
  'postalCode.input.placeholder': 'Zip code',

  'header.financialHealthScore': 'Learn Your Financial Health Score',

  householdSpending: 'Which of the following best describes your household spending compared to income?',
  'householdSpending.1': 'Spending <b>much more than</b> income',
  'householdSpending.25': 'Spending a <b>little more than</b> income',
  'householdSpending.50': 'Spending about <b>equal to</b> income',
  'householdSpending.75': 'Spending a <b>little less than</b> income',
  'householdSpending.100': 'Spending <b>much less than</b> income',

  householdBills: 'Which of the following best describes how your household has paid bills over the past year?',
  'householdBills.1': 'Pay <b>very few</b> of our bills on time',
  'householdBills.35': 'Pay <b>some</b> of our bills on time',
  'householdBills.65': 'Pay <b>most</b> of our bills on time',
  'householdBills.75': 'Pay <b>nearly all</b> our bills on time',
  'householdBills.100': 'Pay <b>all</b> our bills on time',

  expenseTimeFrame: 'At your current level of spending, how long could your household afford to cover expenses?',
  'expenseTimeFrame.tooltip': 'Without borrowing money or withdrawing from retirement accounts',
  'expenseTimeFrame.1': 'Less than a week',
  'expenseTimeFrame.25': '1 to 3 weeks',
  'expenseTimeFrame.50': '1 to 2 months',
  'expenseTimeFrame.75': '3 to 5 months',
  'expenseTimeFrame.100': '6 months or more',

  householdGoalConfidence: 'How confident are you that your household is currently doing what is needed to meet your longer term goals?',
  'householdGoalConfidence.1': '<b>Not at all</b> confident',
  'householdGoalConfidence.35': '<b>Slightly</b> confident',
  'householdGoalConfidence.50': '<b>Somewhat</b> confident',
  'householdGoalConfidence.65': '<b>Moderately</b> confident',
  'householdGoalConfidence.100': '<b>Very</b> confident',

  householdDebts: 'Thinking about all of your household\'s current debts, how would you describe your household\'s debts?',
  'householdDebts.1': 'Have <b>far more</b> debt than is manageable',
  'householdDebts.40': 'Have a <b>bit more</b> debt than is manageable',
  'householdDebts.85': 'Have a <b>manageable amount</b> of debt',
  'householdDebts.100': '<b>Do not have any</b> debt',

  creditExperience: 'What is your experience with credit?',
  'creditExperience.1': 'Poor',
  'creditExperience.25': 'Fair',
  'creditExperience.50': 'Good',
  'creditExperience.75': 'Very good',
  'creditExperience.100': 'Excellent',

  householdInsuranceConfidence: 'How confident are you that your household\'s insurance policies for life, health, home and auto will provide enough support in case of an emergency?',
  'householdInsuranceConfidence.1': '<b>No one</b> in my household <b>has any</b> insurance',
  'householdInsuranceConfidence.15': '<b>Not at all</b> confident',
  'householdInsuranceConfidence.35': '<b>Slightly</b> confident',
  'householdInsuranceConfidence.65': '<b>Moderately</b> confident',
  'householdInsuranceConfidence.100': '<b>Very</b> confident',

  householdPlanningConfidence: 'To what extent do you agree with the statement "My household plans ahead financially"?',
  'householdPlanningConfidence.1': 'Disagree strongly',
  'householdPlanningConfidence.25': 'Disagree somewhat',
  'householdPlanningConfidence.50': 'Neither agree nor disagree',
  'householdPlanningConfidence.75': 'Agree somewhat',
  'householdPlanningConfidence.100': 'Agree strongly',

  /**
   * ============================
   * CONSUMER PRODUCT MESSAGES
   * ============================
   */

  '1326.name': 'LifeGreen Preferred Checking®',
  '1326.type': 'checking',
  '1326.description.abbreviated': 'For those who want to earn interest and benefit from a more extensive relationship with Regions.',
  '1326.url': 'https://www.regions.com/personal-banking/open-checking-account-online/preferred-checking-account',
  '1326.features.count': 4,
  '1326.features.1': 'Enjoy earning interest and unlimited check writing',
  '1326.features.2': 'No Monthly fee on Premium Money Market',
  '1326.features.3': 'No fee on two transactions at non-Regions ATMs per statement period',
  '1326.features.4': 'No fees for printed check images with paper statements, money orders and cashier checks',
  '1326.disclosures.count': 0,
  '1326.applyNow': 'https://jointhebank.regions.com/?productAlias=prefplus',

  '1324.name': 'LifeGreen® Checking for Students',
  '1324.description.abbreviated': 'You\'re age 25 or younger and want the benefits of LifeGreen Checking without a monthly fee.',
  '1324.url': 'https://www.regions.com/personal-banking/open-checking-account-online/student-checking-account',
  '1324.features.count': 3,
  '1324.features.1': 'You are 25 or younger.',
  '1324.features.2': 'No monthly fee.',
  '1324.features.3': 'LifeGreen Savings account with no monthly fee and option to earn an annual savings bonus ',
  '1324.disclosures.count': 0,
  '1324.applyNow': 'https://jointhebank.regions.com/?productAlias=lgstudents',

  '1325.name': 'LifeGreen® 62+ Checking',
  '1325.description.abbreviated': 'Ideal for those age 62+, same great features as LifeGreen Checking.',
  '1325.url':
    'https://www.regions.com/personal-banking/open-checking-account-online/62-plus-retirement-checking-account',
  '1325.features.count': 2,
  '1325.features.1': 'Unlimited check writing',
  '1325.features.2': 'LifeGreen Savings account with no monthly fee and option to earn an annual savings bonus',
  '1325.disclosures.count': 0,
  '1325.url.quickGuide': 'https://www.regions.com/virtualDocuments/QuickGuide-62PlusLifeGreenChecking.pdf',
  '1325.applyNow': 'https://jointhebank.regions.com/?productAlias=lifegreenchkplus',

  '1321.name': 'LifeGreen® Checking',
  '1321.description.abbreviated':'A good fit for those who have direct deposit and want unlimited check writing. ',
  '1321.url': 'https://www.regions.com/personal-banking/open-checking-account-online/lifegreen-checking-account',
  '1321.features.count': 2,
  '1321.features.1': 'Unlimited check writing',
  '1321.features.2': 'LifeGreen Savings account with no monthly fee and option to earn an annual savings bonus',
  '1321.disclosures.count': 0,
  '1321.url.quickGuide': 'https://www.regions.com/virtualDocuments/QuickGuide-LifegreenChecking.pdf',
  '1321.applyNow': 'https://jointhebank.regions.com/?productAlias=lifegreenchk',

  '1322.name': 'LifeGreen eAccess Account®',
  '1322.description.abbreviated': 'Suited for those who do most of their banking online, with little check writing.',
  '1322.url': 'https://www.regions.com/personal-banking/open-checking-account-online/eaccess-checking-account',
  '1322.features.count': 3,
  '1322.features.1': 'You write few checks',
  '1322.features.2': 'Enjoy electronic access',
  '1322.features.3': 'You\'re a frequent Debit/Credit card user ',
  '1322.disclosures.count': 0,
  '1322.url.quickGuide': 'https://www.regions.com/virtualDocuments/QuickGuide-eAccessAccount.pdf',
  '1322.applyNow': 'https://jointhebank.regions.com/?productAlias=lifegreeneaccess',

  '1323.name': 'LifeGreen Simple Checking℠',
  '1323.description.abbreviated': 'For individuals who want great LifeGreen account features but prefer a flat monthly fee.',
  '1323.url': 'https://www.regions.com/personal-banking/open-checking-account-online/simple-checking-account',
  '1323.features.count': 3,
  '1323.features.1': 'Enjoy a predictable monthly fee',
  '1323.features.2': 'Unlimited check writing',
  '1323.features.3': 'LifeGreen Savings account with no monthly fee and option to earn an annual savings bonus',
  '1323.disclosures.count': 0,
  '1323.url.quickGuide': 'https://www.regions.com/virtualDocuments/QuickGuide-SimpleChecking.pdf',
  '1323.applyNow': 'https://jointhebank.regions.com/?productAlias=lifegreensimpchk',

  '1615.name': 'Now Checking℠',
  '1615.description.abbreviated': 'Regions Now Checking gives you the predictability of a low, flat monthly fee¹ with no Standard Overdraft Coverage and no overdraft or non-sufficient fund fees.',
  '1615.url': 'https://www.regions.com/personal-banking/open-checking-account-online/now-checking-account',
  '1615.features.count': 2,
  '1615.features.1': 'Simplify your life with Transfers and Payments² through Online Banking, an easy, safe way to pay almost any merchant anywhere in the United States.',
  '1615.features.2': 'No matter how you choose to bank, we’re there with apps, mobile deposit, Zelle®³, alerts, text banking and more, all on the go.',
  '1615.disclosures.count': 3,
  '1615.disclosures.1': 'The monthly fee is $5; there is no way to avoid this fee.  Regions Standard Overdraft Coverage is a service we provide on many checking accounts that may cover transactions that overdraw the available funds in the account.  We do not provide Standard Overdraft Coverage on Regions Now Checking.  ',
  '1615.disclosures.2': 'You must be at least 18 years of age to use Regions Bill Pay.',
  '1615.disclosures.3': 'Zelle and the Zelle related marks are wholly owned by Early Warning Services, LLC and are used herein under license. Must have a bank account in the U.S.to use Zelle. Your mobile carrier’s message and data fees may apply.  You must be at least 18 years of age to use Zelle.',
  '1615.url.quickGuide': 'https://www.regions.com/virtualDocuments/QuickGuide-SimpleChecking.pdf',
  '1615.applyNow': 'https://jointhebank.regions.com/?productAlias=nowchecking',

  '1351.name': 'Regions Now Card®',
  '1351.description.abbreviated': 'Reloadable Visa® prepaid card is a smart way to control your money.  Safer than cash, secure and easy to use.',
  '1351.url': 'https://www.regions.com/personal-banking/debit-gift-cards/now-card',
  '1351.features.count': 3,
  '1351.features.1': 'Can use almost everywhere Visa® Debit is accepted',
  '1351.features.2': 'No minimum balance requirement',
  '1351.features.3': 'No costly overdraft or interest fees',
  '1351.disclosures.count': 0,
  '1351.url.quickGuide': 'https://www.regions.com/virtualDocuments/QuickGuide-NowCard.pdf',
  '1351.applyNow': 'https://jointhebank.regions.com/?productAlias=nowcard',

  '1334.name': 'Regions Preferred Banking®',
  '1334.description.abbreviated': 'A preferred-customer program that delivers a high level of personal service along with special savings and earnings opportunities...all at no additional cost to you.',
  '1334.url': 'https://www.regions.com/promo/priority-banking-for-consumer',
  '1334.features.count': 3,
  '1334.features.1': 'Personal attention and expertise from your dedicated Priority Banker.',
  '1334.features.2': 'Fast, friendly assistance from the Regions Priority Banking Contact Center – with extended hours available seven days a week including bank holidays.',
  '1334.features.3': 'Special offers on select deposit and lending solutions targeted specifically to your needs.',
  '1334.disclosures.count': 0,
  '1334.url.additionalInfo': 'https://www.regions.com/personal-banking/preferred-banking',
  '1334.appointment': 'http://www.regions.com/',

  '1335.name': 'Premium Money Market',
  '1335.description.abbreviated':'For those wanting better use of their funds and the opportunity to earn premium rates based on additional qualifying relationships.',
  '1335.url': 'https://www.regions.com/personal-banking/open-savings-account-online/premium-money-market',
  '1335.features.count': 3,
  '1335.features.1': 'Opportunity to earn premium rates',
  '1335.features.2': 'Can be linked to your Regions checking account for Overdraft Protection',
  '1335.features.3': 'Can set up an automated savings plan by linking to a Regions checking account',
  '1335.disclosures.count': 0,
  '1335.url.additionalInfo': 'https://www.regions.com/virtualDocuments/Checking-Pricing-Schedule.pdf',
  '1335.applyNow': 'https://jointhebank.regions.com/?productAlias=premiummoneymarket',

  '1336.name': 'Regions Money Market',
  '1336.description.abbreviated': 'For those wanting a basic money market account.',
  '1336.url': 'https://www.regions.com/personal-banking/open-savings-account-online/money-market',
  '1336.features.count': 2,
  '1336.features.1': 'Can be linked to your Regions checking account for Overdraft Protection',
  '1336.features.2': 'Can set up an automated savings plan by linking to a Regions checking account',
  '1336.disclosures.count': 0,
  '1336.url.additionalInfo': 'https://www.regions.com/virtualDocuments/Checking-Pricing-Schedule.pdf',
  '1336.applyNow': 'https://jointhebank.regions.com/?productAlias=moneymarket',

  '1337.name': 'Regions LifeGreen® Savings',
  '1337.description.abbreviated':'For those who want the opportunity to earn a savings bonus<sup>3</sup> but avoid monthly fees and minimum balance requirements on the savings account.',
  '1337.url': 'https://www.regions.com/personal-banking/open-savings-account-online/lifegreen-savings-account',
  '1337.features.count': 3,
  '1337.features.1': 'Get opportunity to earn a 1% annual savings bonus',
  '1337.features.2': 'Enjoy no minimum balance requirement and no monthly fee',
  '1337.features.3': 'Can use for overdraft protection',
  '1337.disclosures.count': 0,
  '1337.url.additionalInfo': 'https://www.regions.com/virtualDocuments/Checking-Pricing-Schedule.pdf',
  '1337.applyNow': 'https://jointhebank.regions.com/?productAlias=lifegreensavings',

  '1338.name': 'Regions Savings',
  '1338.description.abbreviated':'For those who want a basic, low-fee account to help you save. ',
  '1338.url': 'https://www.regions.com/personal-banking/open-savings-account-online/regions-savings-account',
  '1338.features.count': 4,
  '1338.features.1': 'Earn interest on your balances',
  '1338.features.2': 'Can set up an automated savings plan by linking to a Regions checking account',
  '1338.features.3': 'Can use for overdraft protection',
  '1338.features.4': 'No monthly fee when reach $300 in savings ',
  '1338.disclosures.count': 0,
  '1338.url.additionalInfo': 'https://www.regions.com/virtualDocuments/Checking-Pricing-Schedule.pdf',
  '1338.applyNow': 'https://jointhebank.regions.com/?productAlias=savings',

  '1339.name': 'Regions Now Savings®',
  '1339.description.abbreviated': 'For the primary account holder of a Regions Now Card who wants the opportunity to earn savings bonuses but avoid monthly fees and minimum balance requirements on the Now Savings account. ',
  '1339.url': 'https://www.regions.com/personal-banking/open-savings-account-online/now-savings-account',
  '1339.features.count': 3,
  '1339.features.1': 'Exclusively for the primary account holder of a Regions Now Card',
  '1339.features.2': 'Pays interest on all balances',
  '1339.features.3': 'Convenient access through Regions® Online Banking or 1-800-REGIONS',
  '1339.disclosures.count': 0,
  '1339.url.additionalInfo': 'https://www.regions.com/virtualdocuments/Now_Saving_Pricing_Schedule.pdf',
  '1339.applyNow': 'https://jointhebank.regions.com/?productAlias=nowsavings',

  '1362.name': 'Regions Promotional CD',
  '1362.description.abbreviated': 'For those who want the best CD rates and can be flexible with timing. $10,000 minimum opening deposit.',
  '1362.url': 'https://www.regions.com/personal-banking/open-savings-account-online/promotional-cd-account',
  '1362.features.count': 2,
  '1362.features.1': 'Automatically renewable at maturity',
  '1362.features.2': 'FDIC Insurance coverage up to the maximum amount permitted by law',
  '1362.disclosures.count': 0,
  '1362.url.additionalInfo': 'https://www.regions.com/virtualDocuments/Checking-Pricing-Schedule.pdf',
  '1362.appointment': 'https://www.regions.com/',

  '1352.name': 'Regions CD',
  '1352.description.abbreviated': 'For those wanting a competitive rate and a predictable return.',
  '1352.url': 'https://www.regions.com/personal-banking/open-savings-account-online/cd-account',
  '1352.features.count': 2,
  '1352.features.1': 'Automatically renewable at maturity',
  '1352.features.2': 'FDIC Insurance coverage up to the maximum amount permitted by law',
  '1352.disclosures.count': 0,
  '1352.url.additionalInfo': 'https://www.regions.com/virtualDocuments/Checking-Pricing-Schedule.pdf',
  '1352.appointment': 'https://www.regions.com/',

  '1340.name': 'Regions Savings for Minors',
  '1340.description.abbreviated': 'For customers who want to help children under 18 years of age save.',
  '1340.url': 'https://www.regions.com/personal-banking/open-savings-account-online/childrens-savings-account',
  '1340.features.count': 3,
  '1340.features.1': 'Great way to learn the importance of saving money',
  '1340.features.2': 'Open this account with as little as $5',
  '1340.features.3': 'Can set up an automated savings plan by linking to a Regions checking account',
  '1340.disclosures.count': 0,
  '1340.url.additionalInfo': 'https://www.regions.com/personal_banking/minor_savings.rf',
  '1340.appointment': 'https://www.regions.com/',

  '1359.name': 'Private Wealth Management',
  '1359.description.abbreviated': 'For high net-worth individuals looking for personalized financial expertise, Regions Private Wealth Management provides a Wealth Advisor who will design a customized financial strategy, informed by institutional expertise and tailored to your specific needs.',
  '1359.url': 'https://www.regions.com/wealth-management/private-wealth-management',
  '1359.features.count': 3,
  '1359.features.1': 'Supported by a team of subject-matter experts including a Lending Advisor, Trust Advisor, Portfolio Manager, Wealth Strategist and more',
  '1359.features.2': 'Powered by proven financial principles and 100 years of institutional knowledge and expertise',
  '1359.features.3': 'Can manage all different types of assets under one bank',
  '1359.disclosures.count': 0,
  '1359.url.additionalInfo': 'https://www.regions.com/personal_banking/private_wealth_management.rf',
  '1359.wealthAdvisor': 'https://www.regions.com/wealth-management/private-wealth-management-contact',

  '1689.name': 'Speak with a Financial Advisor',
  '1689.description.abbreviated': 'For those wanting personalized, customized guidance on investment and retirement solutions.',
  '1689.url': 'https://www.regions.com/wealth-management/contact-financial-advisor',
  '1689.features.count': 4,
  '1689.features.1': 'Meet with a professional to discuss your financial future',
  '1689.features.2': 'Customized, goals-based retirement plan developed in partnership with Financial Advisor',
  '1689.features.3': 'Review taxed-advantaged retirement accounts',
  '1689.features.4': 'Potentially achieve a higher rate of return on investments than some standard bank products',
  '1689.disclosures.count': 0,
  '1689.url.additionalInfo': 'https://www.regions.com/wealth-management/contact-financial-advisor',
  '1689.financialAdvisor': 'https://www.regions.com/locator?type=fc',

  '1690.name': 'Meet with a Banker',
  '1690.description.abbreviated': 'For those seeking guidance in their savings, retirement, and life insurance options.',
  '1690.url': 'https://www.regions.com/wealth-management/contact-financial-advisor',
  '1690.features.count': 3,
  '1690.features.1': 'Meet with a professional to discuss your financial future',
  '1690.features.2': 'Investment options available at $250 point of entry with a licensed banker',
  '1690.features.3': 'Review tax-advantaged retirement accounts',
  '1690.disclosures.count': 0,
  '1690.url.additionalInfo': 'https://www.regions.com/wealth-management/contact-financial-advisor',
  '1690.appointment': 'https://www.regions.com/locator?type=fc',

  '1691.name': 'Retirement Review with a Financial Advisor',
  '1691.description.abbreviated': 'For those seeking guidance during their retirement journey.',
  '1691.url': 'https://www.regions.com/wealth-management/contact-financial-advisor',
  '1691.features.count': 2,
  '1691.features.1': 'Meet with a professional to discuss managing your money during retirement',
  '1691.features.2': 'Review financial options to meet your goals',
  '1691.disclosures.count': 0,
  '1691.url.additionalInfo': 'https://www.regions.com/wealth-management/contact-financial-advisor',
  '1691.financialAdvisor': 'https://www.regions.com/locator?type=fc',

  '1331.name': 'First-Time Homebuyer Program',
  '1331.description.abbreviated': 'Ideal for first-time homebuyers needing assistance with down payment or closing costs.',
  '1331.url': 'https://www.regions.com/personal-banking/mortgage/mortgage-loan/home-loan-options',
  '1331.features.count': 3,
  '1331.features.1': 'Funds can help with down payment or closing costs',
  '1331.features.2': 'Several down payment options available',
  '1331.features.3': 'Use less of your own money and keep it in the bank',
  '1331.disclosures.count': 0,
  '1331.url.additionalInfo': 'http://www.regions.com/mortgage/first_time_buyers.rf',
  '1331.applyNow': 'https://lending.regions.com/app/buying-and-refinancing/welcome',

  '1329.name': 'Fixed Rate Mortgage',
  '1329.description.abbreviated': 'May be ideal for those who want the security of maintaining the same interest rate over the life of the loan.',
  '1329.url': 'https://www.regions.com/personal-banking/mortgage/mortgage-loan/home-loan-options',
  '1329.features.count': 2,
  '1329.features.1': 'Same interest rate over the life of the loan',
  '1329.features.2': 'Variety of loan terms',
  '1329.disclosures.count': 0,
  '1329.url.additionalInfo': 'https://www.regions.com/personal-banking/mortgage/mortgage-loan/home-loan-options',
  '1329.applyNow': 'https://lending.regions.com/app/buying-and-refinancing/welcome',

  '1330.name': 'Adjustable Rate Mortgage Loan',
  '1330.description.abbreviated': 'May be ideal for those who want the flexibility of a lower starting interest rate and initial monthly payment.',
  '1330.url': 'https://www.regions.com/personal-banking/mortgage/mortgage-loan/home-loan-options',
  '1330.features.count': 3,
  '1330.features.1': 'Lower starting interest rate and lower initial monthly payment',
  '1330.features.2': 'Rates based on market variables',
  '1330.features.3': 'Normally fixed for 3 to 5 years, then becomes adjustable annually',
  '1330.disclosures.count': 0,
  '1330.url.additionalInfo': 'https://www.regions.com/personal-banking/mortgage/mortgage-loan/home-loan-options',
  '1330.applyNow': 'https://lending.regions.com/app/buying-and-refinancing/welcome',

  '1327.name': 'Home Equity Line of Credit',
  '1327.description.abbreviated': 'May be ideal for those looking for a great way to fund home improvements, college tuition or other financial demands.',
  '1327.url': 'https://www.regions.com/personal-banking/home-equity-loans/home-equity-line-of-credit',
  '1327.features.count': 3,
  '1327.features.1': 'Easy access to funds in a variety of methods',
  '1327.features.2': 'Available all at once or in increments, right away or at a later date',
  '1327.features.3': 'Can use the money for multiple purposes',
  '1327.disclosures.count': 0,
  '1327.url.additionalInfo': 'https://www.regions.com/personal-banking/home-equity-loans/home-equity-line-of-credit',
  '1327.applyNow': 'https://origination.regions.com/?product=heloc',

  '1328.name': 'Home Equity Loan',
  '1328.description.abbreviated': 'May be ideal for those who want the convenience of several term-length options and a fixed rate for the life of the loan.',
  '1328.url': 'https://www.regions.com/personal-banking/home-equity-loans/home-equity-loan',
  '1328.features.count': 3,
  '1328.features.1': 'Competitive rates and flexible terms',
  '1328.features.2': 'Bank pays or waives all closing costs up to $250,000',
  '1328.features.3': 'Fixed rate over the life of your loan',
  '1328.disclosures.count': 0,
  '1328.url.additionalInfo': 'https://www.regions.com/personal-banking/home-equity-loans/home-equity-loan',
  '1328.applyNow': 'https://lending.regions.com/app/home-equity-loan/welcome',

  '1364.name': 'Auto Loan',
  '1364.description.abbreviated': 'May be ideal for those looking for a new/used auto loan or to refinance. Choose between three convenient ways to apply.',
  '1364.url': 'https://www.regions.com/personal-banking/auto-center/auto-loans',
  '1364.features.count': 1,
  '1364.features.1': 'Competitive rates and flexible terms',
  '1364.features.2': 'Can be done entirely online at your convenience',
  '1364.features.3': 'Rate discounts available with automatic payments from a Regions checking account',
  '1364.disclosures.count': 0,
  '1364.url.additionalInfo': 'https://www.regions.com/personal-banking/auto-center/auto-loans',
  '1364.applyNow': 'https://lending.regions.com/app/auto-loans/welcome',

  '1365.name': 'Auto Loan Refinance',
  '1365.description.abbreviated': 'May be ideal for those who want to refinance a car loan. Process is entirely online for your convenience.',
  '1365.url': 'https://www.regions.com/personal-banking/auto-center/auto-loans',
  '1365.features.count': 3,
  '1365.features.1': 'Competitive rates and flexible terms',
  '1365.features.2': 'No loan processing fee',
  '1365.features.3': 'Can be handled online, phone or branch',
  '1365.disclosures.count': 0,
  '1365.url.additionalInfo': 'https://www.regions.com/personal-banking/auto-center/auto-loans',
  '1365.applyNow': 'https://lending.regions.com/app/auto-loans/welcome',

  '1366.name': 'Secured Installment Loan',
  '1366.description.abbreviated': 'Can be used for a variety of financial needs. Funds are available in a single lump sum.',
  '1366.url': 'https://www.regions.com/personal-banking/auto-center/auto-loans',
  '1366.features.count': 3,
  '1366.features.1': 'Competitive rates',
  '1366.features.2': 'A wide range of collateral options',
  '1366.features.3': 'Funds are available immediately at closing',
  '1366.disclosures.count': 0,
  '1366.url.additionalInfo': 'https://www.regions.com/personal-banking/auto-center/auto-loans',
  '1366.appointment': 'https://www.regions.com/',

  '1371.name': 'Savings Secured Line of Credit',
  '1371.description.abbreviated': 'May be ideal to fund car repairs or vacations. Link to your Regions checking account for overdraft protection.',
  '1371.url': 'https://www.regions.com/personal-banking/personal-loans/deposit-secured-loan',
  '1371.features.count': 3,
  '1371.features.1': 'Can use the money for multiple purposes',
  '1371.features.2': 'Borrow as little or as much as you need up to your available credit limit',
  '1371.features.3': 'The total credit limit is secured by your Regions savings account',
  '1371.disclosures.count': 0,
  '1371.url.additionalInfo': 'https://www.regions.com/personal-banking/personal-lines-of-credit/savings-secured-line-of-credit',
  '1371.applyNow': 'https://lending.regions.com/app/savings-secured/welcome',

  '1370.name': 'Deposit Secured Loan',
  '1370.description.abbreviated': 'May be ideal for those who want to use funds from a  Regions Certificate of Deposit or a Regions Savings Account as collateral.',
  '1370.url': 'https://www.regions.com/personal-banking/personal-loans/deposit-secured-loan',
  '1370.features.count': 1,
  '1370.features.1': 'Can use the money for multiple purposes',
  '1370.features.2': 'Predictable monthly payments and low interest rates',
  '1370.features.3': 'Funds are available immediately at closing',
  '1370.disclosures.count': 0,
  '1370.url.additionalInfo': 'https://www.regions.com/personal-banking/personal-loans/deposit-secured-loan',
  '1370.applyNow': 'https://lending.regions.com/app/deposit-secured/welcome',

  '1332.name': 'Preferred Line of Credit',
  '1332.description.abbreviated': 'Requires no collateral and can be used for home improvement projects, car repairs and unexpected expenses.',
  '1332.url': 'https://www.regions.com/personal-banking/personal-lines-of-credit/preferred-line-of-credit',
  '1332.features.count': 3,
  '1332.features.1': 'Easy access to funds in a variety of methods',
  '1332.features.2': 'Can use the money for multiple purposes',
  '1332.features.3': 'Borrow as little or as much as you need up to your available credit limit',
  '1332.disclosures.count': 0,
  '1332.url.additionalInfo': 'https://www.regions.com/personal-banking/personal-lines-of-credit/preferred-line-of-credit',
  '1332.applyNow': 'https://lending.regions.com/app/preferred-line-of-credit/welcome',

  '1367.name': 'Regions Credit Line',
  '1367.description.abbreviated': 'A small-dollar line of credit that allows funds to be borrowed, repaid and borrowed again. Link to your Regions checking account for overdraft protection.',
  '1367.url': 'https://www.regions.com/personal-banking/personal-lines-of-credit/credit-line',
  '1367.features.count': 2,
  '1367.features.1': 'Can use to fund emergency needs',
  '1367.features.2': 'Borrow as little or as much as you need up to your available credit limit',
  '1367.disclosures.count': 0,
  '1367.url.additionalInfo': 'https://www.regions.com/personal-banking/personal-lines-of-credit/credit-line',
  '1367.applyNow': 'https://lending.regions.com/app/standard-line-of-credit/welcome',

  '1368.name': 'Regions Personal Unsecured Loan',
  '1368.description.abbreviated': 'May be ideal for those who need money in a single lump sum with no collateral required.',
  '1368.url': 'https://www.regions.com/personal-banking/personal-loans/personal-unsecured-loan',
  '1368.features.count': 3,
  '1368.features.1': 'No collateral required',
  '1368.features.2': 'Borrow up to $35,000',
  '1368.features.3': 'Fixed interest rate with predictable monthly payments',
  '1368.disclosures.count': 0,
  '1368.url.additionalInfo': 'https://www.regions.com/personal-banking/personal-loans/personal-unsecured-loan',
  '1368.applyNow': 'https://personalloan.regions.com',

  '1468.name': 'Regions Personal Unsecured Loan',
  '1468.description.abbreviated': 'May be ideal for those who need money in a single lump sum with no collateral required.',
  '1468.url': 'https://www.regions.com/personal-banking/personal-loans/personal-unsecured-loan',
  '1468.features.count': 3,
  '1468.features.1': 'No collateral required',
  '1468.features.2': 'Borrow up to $50,000',
  '1468.features.3': 'Fixed interest rate with predictable monthly payments',
  '1468.disclosures.count': 0,
  '1468.url.additionalInfo': 'https://www.regions.com/personal-banking/personal-loans/personal-unsecured-loan',
  '1468.appointment': 'http://www.regions.com/',

  '1372.name': 'Sallie Mae Smart Option Student Loan®',
  '1372.description.abbreviated': 'May be ideal for those who need a way to pay for college expenses at a degree-granting institution.',
  '1372.url': 'https://www.regions.com/personal-banking/borrow/student-loans-sallie-mae',
  '1372.features.count': 3,
  '1372.features.1': 'Variety of funding and repayment options',
  '1372.features.2': 'Easy online application with fast credit result and electronic signature available',
  '1372.features.3': 'Can apply with a cosigner to improve chances for approval',
  '1372.disclosures.count': 0,
  '1372.url.additionalInfo': 'https://www.regions.com/personal-banking/borrow/student-loans-sallie-mae',
  '1372.applyNow': 'https://www.salliemae.com/landing/student-loans',

  '1431.name': 'Regions Premium℠ Visa® Signature',
  '1431.description.abbreviated': 'For those who want enhanced earning through the Relationship Rewards® program.',
  '1431.url': 'https://www.regions.com/personal-banking/credit-cards/premium-credit-card',
  '1431.features.count': 3,
  '1431.features.1': 'No foreign transaction fees',
  '1431.features.2': 'Enhanced introductory rate offer',
  '1431.features.3': 'Excellent card benefits, including Regions Relationship Rewards',
  '1431.disclosures.count': 0,
  '1431.url.additionalInfo': 'https://www.regions.com/personal-banking/credit-cards/premium-credit-card',
  '1431.applyNow': 'https://apply.regions.com/consumer?productAlias=visapremium',
  '1431.rewardsAndPricingInfo': ' See <rewards>rewards details</rewards> and <pricing>pricing</pricing> information.',

  '1433.name': 'Regions Prestige℠ Visa® Signature Credit Card',
  '1433.description.abbreviated': 'Ideal for customers who want to earn more rewards on everyday purchases, like gas and groceries, with no annual fee',
  '1433.url': 'https://www.regions.com/personal-banking/credit-cards/prestige-credit-card',
  '1433.features.count': 5,
  '1433.features.1': 'Earn 3% on dining & entertainment, 2% on gas & groceries, and 1% on all other purchases',
  '1433.features.2': 'Increase your rewards up to 4%, 3% and 2% when you register for <href>http://regions.com/rewardsmultiplier||Rewards Multiplier</href> and maintain certain balances in your Regions checking and other deposit accounts',
  '1433.features.3': 'Earn cash back when you activate Regions Offers in Online or Mobile Banking and use your card to make eligible purchases',
  '1433.features.4': 'Enjoy standard security & convenience features including activity alerts, Regions LockIt, Tap to Pay, and Mobile Pay',
  '1433.features.5': 'Other card benefits include Visa Zero Liability Policy<sup>1</sup>, Purchase Security, Extended Warranty Protection, and more',
  '1433.disclosures.count': 2,
  '1433.disclosures.1': 'The Visa Zero Liability Policy does not apply if you have been fraudulent or negligent in handling your card or account.',
  '1433.disclosures.2': 'View the Quick Guide to learn more about the Annual Percentage Rates (APRs) and certain fees that apply to this card.',
  '1433.url.additionalInfo': 'https://www.regions.com/personal-banking/credit-cards/prestige-credit-card',
  '1433.applyNow': 'https://apply.regions.com/consumer?productAlias=visasigr',
  '1433.rewardsAndPricingInfo': ' See <rewards>rewards details</rewards> and <pricing>pricing</pricing> information.',

  '1458.name': 'Regions Cash Rewards Visa® Signature',
  '1458.description.abbreviated': 'For those who want the Cash Rewards program and no annual fee.',
  '1458.url': 'https://www.regions.com/personal-banking/credit-cards/cash-rewards-card',
  '1458.features.count': 3,
  '1458.features.1': 'Cash rewards',
  '1458.features.2': 'No annual or foreign transaction fees',
  '1458.features.3': 'Enhanced introductory rate offer',
  '1458.disclosures.count': 1,
  '1458.disclosures.1': 'Apple Pay is a trademark of Apple Inc. Google Pay is a trademark of Google, Inc. Samsung Pay is a trademark of Samsung Electronics Co., Ltd. LG Pay is a trademark of LG Corp.',
  '1458.url.additionalInfo': 'https://www.regions.com/personal-banking/credit-cards/cash-rewards-card',
  '1458.applyNow': 'https://apply.regions.com/consumer?productAlias=cashvisasigr',
  '1458.rewardsAndPricingInfo': ' See <rewards>rewards details</rewards> and <pricing>pricing</pricing> information.',

  '1434.name': 'Regions Life℠ Visa® Credit Card',
  '1434.description.abbreviated': 'For those who want a lower rate with no annual fee.',
  '1434.url': 'https://www.regions.com/personal-banking/credit-cards/life-credit-card  ',
  '1434.features.count': 3,
  '1434.features.1': 'Low rates',
  '1434.features.2': 'No annual or foreign transaction fees',
  '1434.features.3': 'Enhanced introductory rate offer ',
  '1434.disclosures.count': 0,
  '1434.url.additionalInfo': 'https://www.regions.com/personal-banking/credit-cards/life-credit-card',
  '1434.applyNow': 'https://apply.regions.com/consumer?productAlias=visaplatn',

  '1613.name': 'Regions Explore℠ Visa® Credit Card',
  '1613.description.abbreviated': 'For those who want to build positive credit history through responsible use. ',
  '1613.url': 'https://www.regions.com/personal-banking/credit-cards/explore-card',
  '1613.features.count': 3,
  '1613.features.1': 'Acceptance and security of using a Visa credit card with chip technology.',
  '1613.features.2': 'Can help to build positive credit history through responsible use.',
  '1613.features.3': 'Convenience of managing and paying your credit card online.',
  '1613.disclosures.count': 0,
  '1613.url.quickGuide': 'https://www.regions.com/virtualdocuments/QuickGuide-PersonalCreditCard.pdf',
  '1613.applyNow': 'https://apply.regions.com/explore/gettingstarted',
};
